
<mat-dialog-content>
  <form [formGroup]="form">
    <h1 *ngIf="!Item?.ItemId" style="font-weight: bold;">{{ 'T4.Service.ItemDialog.txtcreateitem' | translate : 'Create item'}}</h1>
    <h1 *ngIf="Item.ItemId" style="font-weight: bold;">{{ 'T4.Service.ItemDialog.txtupdateitem' | translate : 'Update item'}}</h1>
    <t4-container>

      <mat-form-field appearance="outline" style="margin-bottom: 10px;" class="col-12">
        <mat-label>{{ 'T4.Service.ItemDialog.txtItemId' | translate : 'Item Id'}}</mat-label>
        <input formControlName="ItemIdControl"
               matInput id="txtItemId"
               autocomplete="off"
               rows="1">
        <mat-error>{{ 'T4.Service.ItemDialog.txtitemId_required' | translate : 'Item Id is required'}}</mat-error>
      </mat-form-field>


      <mat-form-field appearance="outline" style="margin-bottom: 10px;" class="col-12">
        <mat-label>{{ 'T4.Service.ItemDialog.txtName' | translate : 'Name'}}</mat-label>
        <input formControlName="ItemNameControl"
               matInput id="txtName"
               autocomplete="off"
               rows="1">
        <mat-error>{{ 'T4.Service.ItemDialog.txtName_required' | translate : 'Item name is required'}}</mat-error>
      </mat-form-field>

    </t4-container>
    <br />
    <div *ngIf="!Item?.ItemId" class="col-12" style="text-align: right; padding-left: 5px; padding-right: 5px;">

      <button mat-flat-button color="primary" style="margin: 3px;" (click)="save()">

        {{'T4.Service.ServiceGuyDialog.cmdConfirm' | translate : 'Save' }}
      </button>
    </div>
    <div *ngIf="Item.ItemId" class="col-12" style="text-align: right; padding-left: 5px; padding-right: 5px;">

      <button mat-flat-button color="primary" style="margin: 3px;" (click)="update()">

        {{'T4.Service.ServiceGuyDialog.cmdConfirm' | translate : 'Save' }}
      </button>
    </div>
  </form>
</mat-dialog-content>
